import Http from "../http";
class NotificationServices{
    static async sendNotification(notificationdata){
        return Http.post('/sendNotification',notificationdata);


    }
    static async sendNotificationToPendingDriver(notificationData){
        return Http.post('/sendNotificationToPendingDriver',notificationData)
    }
}
export default NotificationServices